var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "language-picker"
  }, _vm._l(_vm.languages, function (language) {
    return _c('div', {
      key: language.key,
      staticClass: "language",
      class: language.key === _vm.currentLanguage ? ['isDisabled', 'isActive'] : 'isClickable',
      on: {
        "click": function ($event) {
          return _vm.changeLanguage(language);
        }
      }
    }, [_vm._v(" " + _vm._s(language.key) + " ")]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }